import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PlatformurlPipe } from './pipes/platformurl.pipe';
import { PlatformInformationServiceConfigurator } from './services/platform-information.service';
import { PlatformassetPipe } from './pipes/platformasset.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PlatformurlPipe,
  ],
  exports: [
    PlatformurlPipe,
  ],
  providers: [
    PlatformurlPipe,
    PlatformassetPipe
  ]
})
export class PlatformManagerModule {
  static forRoot(config): ModuleWithProviders<PlatformManagerModule> {
    return {
      ngModule: PlatformManagerModule,
      providers: [
        {
          provide: PlatformInformationServiceConfigurator,
          useValue: config
        }
      ]
    };
  }

  static forFeature(): ModuleWithProviders<PlatformManagerModule> {
    return {
      ngModule: PlatformManagerModule,
      providers: []
    };
  }
}
